module.exports = __webpack_public_path__ + "static/media/right-underline-2-short.aaa6c6d9.svg";